<template>
  <div>
    <HelpPage />
  </div>
</template>

<script>
import HelpPage from '../components/HelpPage';

export default {
  name: 'PlatformHelp',
  components: {
    HelpPage,
  },
};
</script>

<style scoped>

</style>
